const ids = {};
export default function (staticId) {
    if (ids[staticId]) { return ids[staticId]; }
    return (ids[staticId] = 'id-' + Math.round(Math.random() * 10000000) + '-' + (new Date().getTime()));
}
